<div class="modal-header">
    <h5 class="modal-title">Select Proposal Template</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <form [formGroup]="proposalForm">
        <div class="col-12 mb-3">
            <label for="template">Proposal Template</label>
            <select id="template" class="form-select" formControlName="featureGroupTemplateId" required>
                <option *ngFor="let prop of templateProposals" [value]="prop.groupTemplateId">{{prop.groupTemplateName}}</option>
            </select>
        </div>
        <div class="col-12">
            <div class="d-flex">
                <label for="template">Item Pricing</label><br>
                <span style="cursor: pointer; margin-left: 5px;" [ngbPopover]="pricing" triggers="click">
                    <fa-icon [icon]="faQuestionCircle"></fa-icon>
                </span>
            </div>
            <div class="form-check form-check-inline">
                <input id="price_update_false" formControlName="isPriceUpdate" class="form-check-input" type="radio" [value]="false">
                <label for="price_update_false" class="form-check-label" style="font-weight: normal;">Template Price</label>
            </div>
            <div class="form-check form-check-inline">
                <input id="price_update_true" formControlName="isPriceUpdate" class="form-check-input" type="radio" [value]="true">
                <label for="price_update_true" class="form-check-label" style="font-weight: normal;">Current Inventory Price</label>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button (click)="selectProposalTemplate()" type="button" class="btn btn-primary">
        <span>Select Template</span>
    </button>
    <button type="button" class="btn btn-secondary ms-2" (click)="modal.dismiss();">Cancel</button>
</div>
<ng-template #pricing>
    <p><strong>Template Price</strong> Prices set on the template proposal will be applied.</p>
    <p><strong>Current Inventory Price</strong> Prices set on the inventory will be applied.</p>
</ng-template>
